import { EmbedEvent, LiveboardEmbed, MessagePayload } from '@thoughtspot/visual-embed-sdk'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import EmbeddedContent from '../../components/EmbeddedContent'
import { ALL_HIDDEN_ACTIONS, COMMON_THOUGHTSPOT_ACTIONS } from '../../constants'
import Error404 from '../error/Error404'
import isUUID from 'validator/lib/isUUID'
import { logError } from '../../services/error/logger'
import { convertTsUrlToHfIntelligenceUrl } from '../../services/route/tsHfIntelligenceUrlMapper'
import { IMessagePayload } from '../../types'

export const dashboardEmbedId = 'embed-liveboard'

/**
 * If dashboard is empty, TS UI provides an option to Search Data
 * navigate to create-visual
 * This is specific for dashboard and create-visual
 * TS emits other internal routes for Dashboard loads along with change in tabs
 */
const ALLOWED_ROUTES_FROM_DASHBOARD = ['/create-visual']

const Dashboard = () => {
  const queryParams = useParams()
  const { dashboardId } = queryParams
  const [hasError, setHasError] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (dashboardId && !isUUID(dashboardId)) {
      setHasError(true)
    }

    const handleError = (messagePayload: MessagePayload) => {
      const embedError = new Error(`Dashboard: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    }

    const handleRouteChange = (messagePayload: IMessagePayload) => {
      const route = messagePayload.data.currentPath
      const dashboardUrl = convertTsUrlToHfIntelligenceUrl(route)
      if (ALLOWED_ROUTES_FROM_DASHBOARD.includes(dashboardUrl)) {
        navigate(dashboardUrl)
      }
    }

    const embed = new LiveboardEmbed(`#${dashboardEmbedId}`, {
      liveboardId: dashboardId,
      showLiveboardTitle: true,
      hiddenActions: ALL_HIDDEN_ACTIONS,
      ...COMMON_THOUGHTSPOT_ACTIONS,
    })

    void embed.on(EmbedEvent.Error, handleError).on(EmbedEvent.RouteChange, handleRouteChange).render()

    return () => {
      embed.off(EmbedEvent.Error, handleError)
      embed.off(EmbedEvent.RouteChange, handleRouteChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardId])

  if (hasError) {
    return <Error404 />
  }

  return (
    <EmbeddedContent
      id={dashboardEmbedId}
      testId={dashboardEmbedId}
    />
  )
}

export default Dashboard
